import styled, { css } from 'styled-components'
import { defaultProps } from 'recompose'

import BodyBase from './BodyBase'

export const subtitle1Styles = css`
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.15px;
`

const Subtitle1 = styled(BodyBase)`
  ${subtitle1Styles};
`

export default defaultProps({
  as: 'p',
})(Subtitle1)
